<template>
    <Card>
        <div class="card-body">
            <router-link class="btn btn-link" :to="{ name: 'InternalProductTypeCreatePage' }">
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
        </div>
        <FetchTable
            :handle="tableHandle"
            :url="table.url"
            :columns="table.columns"
            v-model:orders="table.orders"
            :has-checkbox="true"
            @update:selectedValues="selectedValues = $event"
        >
            <template #card-body-actions>
                <router-link class="btn btn-link" :to="{ name: 'InternalProductTypeCreatePage' }">
                    <i class="icon-plus3 mr-2"></i>
                    {{ $t('buttons.create') }}
                </router-link>
            </template>
            <template #actionDropdownItems>
                <DropdownItem @click="$refs.DeleteCategoriesModal.show(selectedValues)">{{ $t('buttons.delete') }}</DropdownItem>
            </template>
            <template #td-name="{row}">
                <router-link :to="{ name: 'InternalProductTypeEditPage', params: { categoryUuid: row.uuid } }">{{ row.name }}</router-link>
            </template>
            <template #td-product_item_count="{row}">
                <router-link :to="{ name: 'ProductsIndexPage', query: { 'category_uuids': [row.uuid] } }">
                    {{ row.product_items_count }}
                </router-link>
            </template>
            <template #td-created_at="{row}">
                <span>{{ DateFormatter.formatDateTime(row.created_at) }}</span>
            </template>
            <template #td-updated_at="{row}">
                <span>{{ DateFormatter.formatDateTime(row.updated_at) }}</span>
            </template>
            <template #td-markup="{row}">
                <u class="text-muted">
                    {{ row.markup ? row.markup : $t('labels.empty') }}
                </u>
            </template>
        </FetchTable>
    </Card>
    <DeleteCategoriesModal
        ref="DeleteCategoriesModal"
        @category:deleted="tableHandle.fetchRows()"
    />
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import DateFormatter from '../../../../services/DateFormatter'
import DropdownItem from '../../../../spa/components/btnDropdown/DropdownItem.vue';
import DeleteCategoriesModal from './modals/DeleteCategoriesModal.vue';
export default {
    name: 'IndexCategoryPage',
    components: {
        FetchTable, Card, DropdownItem, DeleteCategoriesModal
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            table: {
                url: `/projects/${this.$route.params.projectUuid}/pim/types`,
                orders: [],
                columns: [
                    {key: 'id', name: translate('table.titles.id'), width: '80px', type: 'string', order: true},
                    {key: 'name', name: translate('table.titles.name'), width: 'auto', type: 'string', order: true},
                    {key: 'markup', name: translate('labels.markup'), width: '150px', type: 'string', order: true},
                    {key: 'product_item_count', name: translate('table.titles.product_item_count'), width: '200px', type: 'string', order: true},
                    {key: 'created_at', name: translate('table.titles.created_at'), width: '200px', type: 'string', order: true},
                    {key: 'updated_at', name: translate('table.titles.updated_at'), width: '200px', type: 'string', order: true},
                ]
            },
            selectedValues: [],
        }
    },
    mounted() {
        this.tableHandle.fetchRows({extra: 1})
    }
}
</script>
